import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["className", "onChatOpen", "dispatch", "sessions", "sortType", "search"];
import React, { forwardRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { AnimatePresence, motion } from 'framer-motion';
import { callIfFunction, cnBem } from "../../../../shared/lib";
import { FSMStages, LoadingStatus, SessionProvider, useAppDispatch, useAppSelector, useFSM, useScrollContext } from "../../../../shared/model";
import { Form } from "../../../../features/form/ui";
import { ScrollButton } from "../../../../features/scroll-button/ui";
import { Navigation } from "../../../../features/search/ui";
import { MessageList } from "../../../../widgets/message-list/ui";
import { selectSessionsList, setContext, setStatus } from "../../../../entities/message/model";
import { selectSearch, selectSortType } from "../../../../entities/filters/model";
import { selectWindowBlocked, setWindowBlocked } from "../../../../entities/settings/model";
import { UnreadedMessagesProvider } from "../../../../entities/message/model/context";
import { ErrorScreen } from "../../../../widgets/error-screen/ui";
import { ChatHeader } from "../ChatHeader";
import styles from "./styles.pcss";
var cnChatWindow = cnBem('chat-window', styles);
var Container = function Container(_ref) {
  var _scrollRef$current$sc, _scrollRef$current;
  var children = _ref.children,
    lockScroll = _ref.lockScroll;
  var _useScrollContext = useScrollContext(),
    scrollRef = _useScrollContext.scrollRef;
  var dispatch = useAppDispatch();
  var windowBlocked = useAppSelector(selectWindowBlocked);
  var closeOverlay = function closeOverlay() {
    dispatch(setWindowBlocked(false));
    dispatch(setContext(undefined));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cnChatWindow('container', {
      windowBlocked: windowBlocked || lockScroll
    }),
    ref: scrollRef
  }, /*#__PURE__*/React.createElement(ChatHeader, null), children, /*#__PURE__*/React.createElement(ScrollButton, {
    className: cnChatWindow('scroll')
  }), /*#__PURE__*/React.createElement(AnimatePresence, {
    custom: windowBlocked,
    initial: false,
    mode: "wait"
  }, windowBlocked && /*#__PURE__*/React.createElement(motion.div, {
    animate: {
      opacity: 1
    },
    "aria-hidden": "true",
    className: cnChatWindow('overlay'),
    exit: {
      opacity: 0
    },
    initial: {
      opacity: 0
    },
    onClick: closeOverlay,
    style: _defineProperty({}, '--overlay-top', "".concat((_scrollRef$current$sc = (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.scrollTop) !== null && _scrollRef$current$sc !== void 0 ? _scrollRef$current$sc : 0, "px"))
  })));
};
var ChatWindowRender = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    onChatOpen = props.onChatOpen,
    _dispatch = props.dispatch,
    sessions = props.sessions,
    sortType = props.sortType,
    search = props.search,
    otherProps = _objectWithoutProperties(props, _excluded);
  useEffect(function () {
    callIfFunction(onChatOpen);
    return function () {
      _dispatch(setStatus(LoadingStatus.idle));
    };
  }, []);
  var _useFSM = useFSM(),
    stage = _useFSM.stage;
  return /*#__PURE__*/React.createElement("section", _extends({
    className: cnChatWindow(null, [className]),
    ref: ref
  }, otherProps), /*#__PURE__*/React.createElement(SessionProvider, {
    search: search,
    sessions: sessions,
    sortType: sortType
  }, /*#__PURE__*/React.createElement(UnreadedMessagesProvider, null, stage === FSMStages.ERROR && /*#__PURE__*/React.createElement(ErrorScreen, {
    className: cnChatWindow('error')
  }), /*#__PURE__*/React.createElement(Container, {
    lockScroll: stage === FSMStages.ERROR
  }, /*#__PURE__*/React.createElement(MessageList, null)), /*#__PURE__*/React.createElement(Form, {
    className: cnChatWindow('form')
  }), /*#__PURE__*/React.createElement(Navigation, null))));
});
var mapStateToProps = function mapStateToProps(store) {
  return {
    search: selectSearch(store),
    sortType: selectSortType(store),
    sessions: selectSessionsList(store)
  };
};
export var ChatWindow = connect(mapStateToProps)(ChatWindowRender);